import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { HashMap, TranslocoService } from '@ngneat/transloco';
import { EMPTY, Subscription } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TranslocoMatPaginatorIntlService extends MatPaginatorIntl implements OnDestroy {
  private readonly langChangesSub: Subscription;

  constructor(private readonly translocoService: TranslocoService) {
    super();

    this.translateLabels();
    this.langChangesSub = this.translocoService.langChanges$
      .pipe(switchMap((lang) => this.translocoService.load(lang).pipe(catchError(() => EMPTY))))
      .subscribe(() => {
        this.translateLabels();
      });
  }

  override getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) {
      return this.t('Range no items', { length });
    }

    const startIndex = page * pageSize + 1;
    const endIndex = Math.min(startIndex + pageSize - 1, length);

    return this.t('Range label', {
      startIndex,
      endIndex,
      length,
    });
  };

  ngOnDestroy(): void {
    this.langChangesSub.unsubscribe();
  }

  private translateLabels(): void {
    this.itemsPerPageLabel = this.t('Items per page');
    this.nextPageLabel = this.t('Next page');
    this.previousPageLabel = this.t('Previous page');
    this.firstPageLabel = this.t('First page');
    this.lastPageLabel = this.t('Last page');
    this.changes.next();
  }

  private t(key: string, params?: HashMap): string {
    return this.translocoService.translate(`transloco-mat-paginator-intl.${key}`, params);
  }
}
